<template>
	<div class = 'home'>
		<div class = 'container'>
			<div class = 'jumbotron d-none d-md-block' style='position: relative; margin-bottom: 0'>
				<div class = 'bixTitle'>
					<h1>Welcome to the BioInformatics Ɔompetence Center</h1>
					<h2>A wide range of expertise to advance your projects</h2>
				</div>
			</div>
			<div class = "d-block d-md-none mb-3">
					<h3>Welcome to the BioInformatics Ɔompetence Center</h3>
					<h4><i>A wide range of expertise to advance your projects</i></h4>
			</div>
			<div class="card text-white bg-dark " style="margin-bottom: 4rem;">
				<div >
					<nav class="nav nav-pills flex-column flex-sm-row">
						<a class="flex-sm-fill text-sm-center nav-link" href="#" @click.prevent="scrollTo('news')">News</a>
						<a class="flex-sm-fill text-sm-center nav-link" href="#" @click.prevent="scrollTo('what')">What can we do</a>
						<a class="flex-sm-fill text-sm-center nav-link" href="#" @click.prevent="scrollTo('contacts')">Contacts</a>
						<a class="flex-sm-fill text-sm-center nav-link" href="#" @click.prevent="scrollTo('work')">Work examples</a>
						<a class="flex-sm-fill text-sm-center nav-link" href="#" @click.prevent="scrollTo('publications')">List of publications</a>
						<a class="flex-sm-fill text-sm-center nav-link" href="#" @click.prevent="scrollTo('policy')">Publication policy</a>
						<a class="flex-sm-fill text-sm-center nav-link" href="#" @click.prevent="scrollTo('steering')">Steering Committee</a>
					</nav>				
				</div>
			</div>
			<div ref="hiring" v-if="hiring">
				<hiring></hiring>
			</div>
			<div ref="news">
				<news></news>
			</div>
			<div ref="what">
				<what-can-do></what-can-do>
			</div>
			<div ref="contacts">
				<contacts></contacts>
			</div>
			<div ref="work">
				<work-examples></work-examples>
			</div>
			<div ref="publications">
				<publication-list></publication-list>
			</div>
			<div ref="policy">
				<publication-policy></publication-policy>
			</div>
			<div ref="steering">
				<steering-committee></steering-committee>
			</div>
		</div>
	</div>
</template>

<script>
import news from '@/components/public/news'
import hiring from '@/components/public/hiring'
import whatCanDo from '@/components/public/whatCanDo'
import contacts from '@/components/public/contacts'
import workExamples from '@/components/public/workExamples'
import publicationPolicy from '@/components/public/publicationPolicy'
import publicationList from '@/components/public/publicationList'
import steeringCommittee from '@/components/public/steeringCommittee'
export default {
	name: 'home',
	components: { news, hiring, whatCanDo, contacts, workExamples,publicationPolicy,publicationList,steeringCommittee},
	data () {
		return {
			hiring: false
		}
	},
	computed: {
	},
	methods: {
		scrollTo(refName) {
			var element = this.$refs[refName];
			element.scrollIntoView({ behavior: 'smooth',block: "center", inline: "nearest" });
		}
	},
	mounted () {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pointer {
	cursor: pointer;
}
h1 {
	padding: 25px 0;
	font-weight: bold;
}
span.cc{
	letter-spacing: -3px;
}
div.homepage {
	margin-top: 0px;
	height: 300px;
/*	background-image: url('../assets/background.jpg');
	background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
/*	text-shadow: 2px 2px #000000;*/
}
div.logoBig{
	position: absolute;
	text-align: center;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	color: white;
	font-size: 300px;
	line-height: 18rem;
	opacity: 0.5;
	z-index: 1;
}
div.logoBig span.cc{
	letter-spacing: -30px;
}
div.jumbotron {
	background-image: url("../assets/bicc_jumbotron.png");
	background-position: center;
	background-repeat: no-repeat;
	padding: 4rem;
	position: relative;
	height: 255px;
}
div.bixTitle {
	color: #FFF;
	position: absolute;
	top: 20px;
	background-color: rgba(4,14,18,0.5);
}
div.bixTitle h1{
	padding: 10px 25px 0 10px;
}
div.bixTitle h2 {
	padding: 0px 25px 0 10px;
}
</style>
